
        import type { TemplateResult, TemplateRootPropsForTag } from 'Components/types';
type relatedItemsRTRootProps = TemplateRootPropsForTag<'div'>;
import { createElement as _createElement } from 'preact';
import { map as _map } from 'Utils/array';
import _translate from 'Utils/translate';
export default function relatedItemsRT(): TemplateResult<relatedItemsRTRootProps> {
    function repeatItems1(discountMode, isHasModalDialog, items, itemsIndex) {
        return [items(function () {
                function repeatBadge1(badge, badgeIndex) {
                    return _createElement('div', {
                        'className': 'product-label product-label--custom1',
                        'key': '782'
                    }, '\n      ', badge, '\n    ');
                }
                function repeatBadge2(badge, badgeIndex) {
                    return _createElement('span', {
                        'className': 'product-label product-label--custom1 cm_badge cm_badge__' + this.toKebabCase(badge),
                        'key': badge
                    }, '\n      ', badge, '\n    ');
                }
                function mergeProps(inline, external) {
                    var res = Object.assign({}, inline, external);
                    if (inline.hasOwnProperty('style')) {
                        res.style = _.defaults(res.style, inline.style);
                    }
                    if (inline.hasOwnProperty('className') && external.hasOwnProperty('className')) {
                        res.className = external.className + ' ' + inline.className;
                    }
                    return res;
                }
                function repeatI4(i, iIndex) {
                    return _createElement('span', {
                        'key': i,
                        'className': 'cm_star cm_star__' + (!(this.review_average - i) || this.review_average - i < 0.25 ? 'empty' : this.review_average - i < 0.75 ? 'half' : 'full')
                    });
                }
                return _createElement('div', { 'className': 'product-item product-item--' + (window.location.pathname.includes('/products/') ? 'vertical' : this.view) + ' 1/3--tablet-and-up 1/4--desk' + (this.is_promotional_item ? ' cm_promotion' : '') }, _createElement.apply(this, [
                    'div',
                    { 'className': 'product-item__label-list' },
                    this.on_sale && discountMode !== 'percentage' ? _createElement('span', {
                        'className': 'product-label product-label--on-sale',
                        'key': '279'
                    }, '\n      ', _translate(`product_badge_save`), ' ', this.formatPrice(this.compare_at_price - this.price), '\n    ') : null,
                    this.on_sale && discountMode === 'percentage' ? _createElement('span', {
                        'className': 'product-label product-label--on-sale',
                        'key': '516'
                    }, '\n      ', _translate(`product_badge_save`), ' ', Math.round((this.compare_at_price - this.price) * 100 / this.compare_at_price), '%\n    ') : null,
                    this.custom_badges ? _map(this.custom_badges, repeatBadge1.bind(this)) : null,
                    this._badges ? _map(this._badges, repeatBadge2.bind(this)) : null
                ]), _createElement('a', {
                    'href': this.url,
                    'className': 'product-item__image-wrapper' + (this.image2 ? ' product-item__image-wrapper--with-secondary' : '')
                }, _createElement('div', {
                    'className': 'aspect-ratio aspect-ratio--square',
                    'style': { paddingBottom: '100%' }
                }, _createElement('img', {
                    'className': 'product-item__primary-image image--fade-in lazyautosizes lazyloaded',
                    'src': this.imageOrDefault(this.resizeImage(this.image)),
                    'alt': this.removeHTML(this.title),
                    'onError': this.onImageError
                }), this.image2 ? _createElement('img', {
                    'className': 'product-item__secondary-image image--fade-in lazyautosizes lazyloaded',
                    'src': this.imageOrDefault(this.resizeImage(this.image2)),
                    'alt': this.removeHTML(this.title),
                    'onError': e => this.onImageError(e, 'image2'),
                    'key': '1577'
                }) : null)), _createElement('div', { 'className': 'product-item__info' }, _createElement('div', { 'className': 'product-item__info-inner' }, this.sku ? _createElement('span', {
                    'className': 'product-item__vendor link',
                    'key': '1940'
                }, this.removeHTML(this.sku)) : null, _createElement('div', { 'className': 'product-item__price-list price-list' }, this.on_sale ? [
                    _createElement('span', {
                        'className': 'price price--highlight',
                        'key': '20961'
                    }, '\n            ', this.price_varies ? `${ _translate(`price_from`) } ${ this.formatPrice(this.price) }` : this.formatPrice(this.price), '\n          '),
                    _createElement('span', {
                        'className': 'price price--compare',
                        'key': '20963'
                    }, this.formatPrice(this.compare_at_price))
                ] : null, !this.on_sale ? _createElement('span', {
                    'className': 'price',
                    'key': '2471'
                }, '\n          ', this.price_varies ? `${ _translate(`price_from`) } ${ this.formatPrice(this.price) }` : this.formatPrice(this.price), '\n        ') : null, this.set_qty ? _createElement('div', {
                    'className': 'price-item--set',
                    'key': '2685'
                }, '\n          ', _translate(`product_set_of`, {  count: this.set_qty  }), ': ', this.formatPrice(this.price * this.set_qty), '\n        ') : null), _createElement('a', mergeProps({
                    'href': this.url,
                    'className': 'product-item__title text--strong link'
                }, { dangerouslySetInnerHTML: { __html: typeof this.breakWordOnSlash(this.title) === 'undefined' ? '' : this.breakWordOnSlash(this.title) } })), [this.review_count ? _createElement.apply(this, [
                        'div',
                        {
                            'className': 'cm_review-stars',
                            'key': '31300'
                        },
                        _map([
                            0,
                            1,
                            2,
                            3,
                            4
                        ], repeatI4.bind(this)),
                        _createElement('span', { 'className': 'cm_review-count' }, this.review_count, ' ', _translate(`product_reviews_title`))
                    ]) : null], !this.doNotShowInventory ? [
                    this.out_of_stock ? _createElement('span', {
                        'className': 'product-item__inventory inventory',
                        'key': '35701'
                    }, '\n          ', _translate(`product_badge_out_of_stock`), '\n        ') : null,
                    this.is_backorder ? _createElement('span', {
                        'className': 'wd-custom-inventory product-item__inventory inventory wd-backorder',
                        'key': '35703'
                    }, '\n          ', _translate(`product_badge_backorder`), '\n        ') : null,
                    this.is_made_to_order ? _createElement('span', {
                        'className': 'wd-custom-inventory product-item__inventory inventory wd-made_to_order',
                        'key': '35705'
                    }, '\n          ', _translate(`product_badge_made_to_order`), '\n        ') : null,
                    this.is_in_stock || this.is_low_stock ? _createElement('span', {
                        'className': 'product-item__inventory inventory inventory--high',
                        'key': '35707'
                    }, '\n          ', _translate(`product_badge_inventory_high`), '\n        ') : null
                ] : null, this.price ? _createElement('p', {
                    'className': 'affirm-as-low-as',
                    'data-amount': this.price * 100,
                    'data-affirm-type': 'logo',
                    'data-affirm-color': 'blue',
                    'key': '4364'
                }) : null), _createElement('form', {
                    'method': 'post',
                    'action': '/cart/add',
                    'acceptCharset': 'UTF-8',
                    'className': 'product-item__action-list button-stack',
                    'encType': 'multipart/form-data'
                }, _createElement('input', {
                    'type': 'hidden',
                    'name': 'quantity',
                    'value': this.set_qty || 1
                }), _createElement('input', {
                    'type': 'hidden',
                    'name': 'id',
                    'value': this.variant_ids
                }), this.out_of_stock ? _createElement('button', {
                    'className': 'product-item__action-button button button--small button--disabled',
                    'disabled': true,
                    'key': '4795'
                }, '\n        ', _translate(`product_button_sold_out`), '\n      ') : null, !this.out_of_stock && this.variant_ids.length === 1 ? _createElement('button', {
                    'type': 'submit',
                    'className': 'product-item__action-button product-item__action-button--list-view-only button button--small button--primary',
                    'data-action': 'add-to-cart',
                    'key': '4987'
                }, '\n        ', _translate(`product_button_add_to_cart`), '\n      ') : null, !this.out_of_stock && this.variant_ids.length > 1 ? _createElement('a', {
                    'href': this.url,
                    'className': 'product-item__action-button product-item__action-button--list-view-only button button--small button--primary',
                    'key': '5295'
                }, '\n        ', _translate(`product_button_choose_options`), '\n      ') : null, isHasModalDialog ? _createElement('button', {
                    'type': 'button',
                    'className': 'product-item__action-button product-item__action-button--list-view-only button button--small button--ternary hidden-phone',
                    'data-action': 'open-modal',
                    'data-secondary-action': 'open-quick-view',
                    'aria-controls': 'modal-quick-view',
                    'data-product-url': this.url,
                    'key': '5576'
                }, '\n        ', _translate(`product_button_quick_view`), '\n      ') : null)));
            }, { count: undefined })];
    }
    function scopeDiscountModeIsHasModalDialog2() {
        var discountMode = window.theme?.discountMode;
        var isHasModalDialog = window.document.querySelector('.modal__dialog');
        return _createElement.apply(this, [
            'div',
            { 'className': 'cm_related-products-list cmRepeater_items' },
            _map(this.items, repeatItems1.bind(this, discountMode, isHasModalDialog))
        ]);
    }
    return _createElement('div', { 'className': 'cm_related-products' }, _createElement('div', { 'className': 'section__header cm_related-products-title-container' }, _createElement('h2', { 'className': 'section__title heading h3 cm_related-products-title' }, _translate(`related_items_title`))), scopeDiscountModeIsHasModalDialog2.apply(this, []));
}
        export const componentNames = []